import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const ICON_CONTAINER_WIDTH = '36px';

export const styles = createTypedSxStyles({
  container: {
    padding: '8px 16px',
    minHeight: '48px',
    cursor: 'pointer',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      backgroundColor: capitalDesignTokens.foundations.colors.gray200
    }
  },
  selected: {
    paddingLeft: '8px',
    borderLeft: `6px solid ${capitalDesignTokens.foundations.colors.brand800}`,
    backgroundColor: capitalDesignTokens.foundations.colors.brand50,
    '&:hover': {
      backgroundColor: capitalDesignTokens.foundations.colors.brand200
    }
  },
  small: {
    minHeight: '40px',
    paddingTop: '4px',
    paddingBottom: '4px'
  },
  icon: {
    '&.MuiListItemIcon-root': {
      width: ICON_CONTAINER_WIDTH,
      color: capitalDesignTokens.foundations.colors.gray500
    }
  },
  selectedIcon: {
    '&.MuiListItemIcon-root': {
      width: ICON_CONTAINER_WIDTH,
      color: capitalDesignTokens.foundations.colors.gray800
    }
  },
  text: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal
  },
  selectedText: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    paddingRight: '32px'
  },
  secondaryActionIcon: {
    height: '20px',
    width: '20px'
  }
});
